module.exports = __webpack_public_path__ + "img/v29.831f7d06.jpg";